module.exports = __webpack_public_path__ + "static/media/serviciosdigitales.18fcd55d.jpg";